<template>
  <div id="button">
    <slot name="button"></slot>
  </div>
  <div id="tooltip">
    <div id="arrow" data-popper-arrow></div>
    <slot name="tooltip"></slot>
  </div>
</template>
<style scoped lang="scss">
#tooltip {
  background: #9d9d9d;
  color: white;
  border: 1px solid black;
  font-weight: bold;
  padding: 4px 8px;
  font-size: 13px;
  border-radius: 4px;
  display: none;
}

#tooltip[data-show] {
  display: block;
}

#arrow,
#arrow::before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

#arrow {
  visibility: hidden;
}

#arrow::before {
  visibility: visible;
  content: "";
  transform: rotate(45deg);
  border-top: 1px solid black;
  border-left: 1px solid black;
}

#tooltip[data-popper-placement^="top"] > #arrow {
  bottom: -4px;
}

#tooltip[data-popper-placement^="bottom"] > #arrow {
  top: -4px;
}

#tooltip[data-popper-placement^="left"] > #arrow {
  right: -4px;
}

#tooltip[data-popper-placement^="right"] > #arrow {
  left: -4px;
}
</style>
<script lang="ts">
import { nextTick, onMounted, ref } from "vue";
import { createPopper } from "@popperjs/core";

export default {
  setup() {
    const data = {
      tooltipCreated: ref<boolean>(false),
    };
    const tooltipInit = () => {
      if (data.tooltipCreated.value) {
        return;
      }
      data.tooltipCreated.value = true;
      nextTick(() => {
        const button = document.querySelector("#button") as Element;
        const tooltip = document.querySelector("#tooltip") as HTMLElement;
        const popper = createPopper(button, tooltip, {
          placement: "bottom",
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 8],
              },
            },
          ],
        });
        button.addEventListener("click", (event) => {
          event.stopPropagation();
          if (tooltip.getAttribute("data-show") != null) {
            tooltip.removeAttribute("data-show");
          } else {
            tooltip.setAttribute("data-show", "");
          }
          popper.update();
        });
        document.addEventListener("click", () => {
          tooltip.removeAttribute("data-show");
          popper.update();
        });
      });
    };
    onMounted(() => {
      tooltipInit();
    });
    return {
      ...data,
    };
  },
};
</script>
